import { useState } from 'react'
import { colors } from 'settings/colors'

export const CommentTextarea = ({ resetKey }: { resetKey: number }) => {
  const [value, setValue] = useState('')

  return (
    <textarea
      key={resetKey}
      className="report-textarea"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      css={{
        marginTop: 20,
        width: '100%',
        minHeight: 80,
        padding: 8,
        border: `1px dashed ${colors.gray}`,
        resize: 'vertical',
        fontSize: 14,
        backgroundColor: colors.grey50,
      }}
    />
  )
}
